
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ranker-rewards-terms",
      function () {
        return require("private-next-pages/ranker-rewards-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ranker-rewards-terms"])
      });
    }
  